import React from 'react'
import { Row, Col } from "antd";
import Feature from "../component/FeaturesSection"

function SupportArtist() {
    return (
        <>
            <div className="support">
                <Row>
                    <Col span={24}>
                        <div className="introduct">
                            <Row>
                                <Col span={24}>
                                    <h2 className='text-center text-[#000] font-cinzel text-[32px]'>How We Support Artists</h2>
                                    <Feature />
                                </Col>

                            </Row>
                        </div>
                    </Col>

                </Row>
            </div>
        </>
    )
}

export default SupportArtist